import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  IApprovedAmountsUpdateRequest,
  ICostTypeCreateRequest,
  ICostTypeUpdateRequest,
} from '../models/cost-type-request.model';
import { ICostTypeDetails } from '../models/cost-type.model';
import { CostTypeEnum } from '../models/enums/cost-type.enum';

@Injectable({
  providedIn: 'root',
})
export class CostTypeApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.services.claims}/api/cost-types`;

  public getOptions(claimId: number): Observable<CostTypeEnum[]> {
    return this.http.get<CostTypeEnum[]>(`${this.baseUrl}/options/${claimId}`);
  }

  public createCostType(
    body: ICostTypeCreateRequest
  ): Observable<ICostTypeDetails> {
    return this.http.post<ICostTypeDetails>(this.baseUrl, body);
  }

  public updateCostType(
    costTypeId: number,
    body: ICostTypeUpdateRequest
  ): Observable<ICostTypeDetails> {
    return this.putCostType(costTypeId, body);
  }

  public updateApprovedAmounts(
    costTypeId: number,
    body: IApprovedAmountsUpdateRequest
  ): Observable<ICostTypeDetails> {
    return this.putCostType(costTypeId, body);
  }

  private putCostType(
    costTypeId: number,
    body: ICostTypeUpdateRequest | IApprovedAmountsUpdateRequest
  ): Observable<ICostTypeDetails> {
    return this.http.put<ICostTypeDetails>(
      `${this.baseUrl}/${costTypeId}`,
      body
    );
  }

  public deleteCostType(costTypeId: number): Observable<void> {
    return this.http.delete<void>(this.baseUrl, {
      params: { costTypeId },
    });
  }
}
